<template>
  <Walkthrough 
    roomName="Cella della Prigione"
    roomKey="jailcell"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="italian"
  />
</template>
<script>

export default {
  name: 'Celda',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/jailcell-1920x1280.jpg",
      steps: [
        "Guarda giù e ispeziona il pavimento. Dovresti trovare una chiave inglese sotto un mattone allentato.",
        "Guarda a destra e ispeziona lo specchio. Dovresti trovare una vecchia lima per unghie nascosta li.",
        "Guarda di fronte e ispeziona il letto. Troverai una divisa da prigione sotto di esso.",
        "Ora usa la lima per unghie sul letto. Raschierai via della pittura e sotto troverai dei disegni di uno specchio, un lavandino, una porta e un condotto d'aria.",
        "Sempre guardando davanti, ispeziona il cuscino, dovresti trovare un pugnale. Ti sarà utile più avanti. Non dimenticarti di prenderlo. ;)",
        "Le immagini sul letto erano effettivamente indizi. usando la direzione dove trovi questi oggetti, ora sai come girare la chiave inglese. Guarda a destra e usa la chiave inglese sul condotto. Girala a destra, destra, sinistra, poi sopra. Questo farà tornare l'acqua alla cella.",
        "Con l'acqua che scorre, guarda nuovamente davanti e usa la divisa da prigioniero nel gabinetto e lanciala li.",
        "Con la divisa bloccata nel gabinetto, usa nuovamente il gabinetto. L'acqua inizierà a fuoriuscire e il livello dell'acqua si innalzerà, fino a portarti al condotto d'aria dove userai il pugnale per aprirla e liberarti. Congratulazioni, sei scappato. Prova a completare la prossima stanza da solo!"
        ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/it/jailcell.vue